import React from 'react';

export default function Loading(props: any) {
    return (
        <div
            className='d-flex justify-content-center'
            style={{
                position: 'relative',
            }}
        >
            <div
                className='loader'
                style={{
                    position: 'absolute',
                    top: '0',
                    margin: 'auto',
                    opacity: props.show ? 1 : 0,
                    transition: 'opacity 0.5s ease-in-out',
                    transitionDelay: '1s',
                }}
            />
            <div
                style={{
                    opacity: props.show ? 0 : 1,
                    transition: 'opacity 0.5s ease-in-out',
                    transitionDelay: '1s',
                }}
            >
                {props.children}
            </div>
        </div>
    );
}
